<button
  [type]="tipo"
  (click)="click()"
  [ngClass]="classe"
  [disabled]="desabilitado || executando">

    <span [ngClass]="posicaoDoIcone === 'esquerda' ? 'float-left' : 'float-right'">
      <span *ngIf="executando"><i [ngClass]="iconeExecutando"></i></span>
      <span *ngIf="!executando"><i [ngClass]="icone"></i></span>
    </span>

    <span *ngIf="texto && texto !== ''" [ngStyle]="{'font-size': tamanhoDoTexto}">
        {{executando ? textoExecutando : texto}}
    </span>

</button>
